import { type TFunctionNonStrict } from 'i18next';

import { ENV } from '../app/env';

interface GenerateInviteLinkArgsType {
  t: TFunctionNonStrict<'translation', undefined>;
  refId?: string;
}

interface GenerateInviteLinkReturnType {
  fullLink: string;
  inviteLink: string;
  shareText: string;
}

const generateInviteLink = ({
  t,
  refId,
}: GenerateInviteLinkArgsType): GenerateInviteLinkReturnType => {
  const inviteLink = `https://t.me/${ENV.TELEGRAM_BOT_NAME}/game?startapp=${refId}`;
  const shareText = `${t('🚀 Build your industrial empire and compete for leadership!')} \n \n ${t('Here you will find a competitive spirit, creative mechanics, interaction with friends and epic clan battles! Develop your production, sign contracts and prove that you are the boss of StarIndustry!')} \n \n ${t('🔥 Ready for the challenge? Click the link and get in the game:')}`;
  const fullLink = `https://t.me/share/url?url=${encodeURIComponent(inviteLink)}&text=${encodeURIComponent(shareText)}`;

  return { inviteLink, shareText, fullLink };
};

export { generateInviteLink };
